import { MsalProvider } from "@azure/msal-react";
import type { ReactNode } from "react";
import { msalInstance } from "./authConfig";

interface AuthProviderProps {
  children: ReactNode;
}

/**
 * MSAL Authentication Provider Component
 * 
 * This component wraps the application with MsalProvider to enable
 * authentication functionality throughout the app.
 */
export const AuthProvider = ({ children }: AuthProviderProps) => {
  return (
    <MsalProvider instance={msalInstance}>
      {children}
    </MsalProvider>
  );
};

export default AuthProvider;
